/* User Management → extra rights: view-only Order Register services + per-panel View / Edit. */
export const RIGHTS_PANELS = [
  ["database_a", "Database A"], ["returned_parcels", "Returned Parcels"], ["product_aliases", "Product Aliases"],
  ["bulk_data", "Bulk Data"], ["packing_list", "Packing List"], ["bulk_label", "Bulk Label"],
  ["pending_parcels", "Pending Parcels (notes)"], ["excel_transpose", "Excel Transpose"], ["pdf_edits", "PDF Edits"],
  ["manage_companies", "Manage Companies"], ["pack_team_print", "Pack Team Print"], ["pdf_to_word", "PDF to Word"],
  ["usa_product_codes", "USA Product Codes"], ["payroll", "Payroll"], ["shipments", "Shipments"],
  ["pb_forms", "PB Forms"], ["edf_form", "EDF Form"], ["advance_tracking", "Advance Tracking"],
];
export const PANEL_LABEL = Object.fromEntries(RIGHTS_PANELS);

/* Compact rights tags for the user list. */
export const RightsTags = ({ u }) => {
  if (!u || u.role === "admin") return null;
  const tags = [];
  if ((u.order_register_view_services || []).length) tags.push([`View: ${u.order_register_view_services.includes("*") ? "All services" : u.order_register_view_services.join(", ")}`, "bg-sky-50 text-sky-700"]);
  Object.entries(u.panel_rights || {}).forEach(([k, v]) => v === "view" && tags.push([`${PANEL_LABEL[k] || k}: View`, "bg-amber-50 text-amber-700"]));
  if (!tags.length) return null;
  return (
    <div className="mt-1 flex flex-wrap gap-1" data-testid={`rights-tags-${u.id}`}>
      {tags.map(([t, c]) => <span key={t} className={`rounded px-1.5 py-px text-[10px] font-semibold ${c}`}>{t}</span>)}
    </div>);
};

const Chip = ({ on, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors ${
      on ? "border-sky-600 bg-sky-600 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-sky-300"}`}>
    {children}
  </button>
);

export const ViewServicesBox = ({ services, editServices, value, setValue }) => {
  const all = value.includes("*");
  const toggle = (s) => setValue(value.includes(s) ? value.filter(x => x !== s) : [...value.filter(x => x !== "*"), s]);
  return (
    <div className="mt-2 ml-5 rounded border border-sky-200 bg-sky-50/60 p-2.5" data-testid="orderreg-view-services-box">
      <p className="mb-0.5 text-[11px] font-semibold text-sky-800">Extra services — view only</p>
      <p className="mb-1.5 text-[10px] text-slate-500">
        Can search, filter, export, add team notes and raise / answer queries on these services (all countries), but edit only the
        allotted services above. Leave empty for no extra view.
      </p>
      <div className="flex flex-wrap gap-1">
        <Chip on={all} onClick={() => setValue(all ? [] : ["*"])} testId="orderreg-view-svc-all">All services</Chip>
        {!all && services.filter(s => !editServices.includes(s)).map(s => (
          <Chip key={s} on={value.includes(s)} onClick={() => toggle(s)} testId={`orderreg-view-svc-${s}`}>{s}</Chip>))}
      </div>
    </div>
  );
};

export const PanelRightsBox = ({ value, setValue }) => (
  <div className="mt-3 rounded border border-slate-200 bg-slate-50 p-2.5" data-testid="panel-rights-box">
    <p className="mb-0.5 text-[11px] font-semibold text-slate-800">Panel rights — View or Edit</p>
    <p className="mb-1.5 text-[10px] text-slate-500">View = can open, search and download; every change is blocked on the server.</p>
    <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">
      {RIGHTS_PANELS.map(([k, label]) => {
        const v = value[k] || "edit";
        return (
          <div key={k} className="flex items-center justify-between rounded bg-white px-2 py-1 text-[11px]" data-testid={`panel-rights-${k}`}>
            <span className="text-slate-700">{label}</span>
            <span className="flex gap-1">
              {["view", "edit"].map(o => (
                <Chip key={o} on={v === o} onClick={() => setValue({ ...value, [k]: o })} testId={`panel-rights-${k}-${o}`}>
                  {o === "view" ? "View" : "Edit"}</Chip>))}
            </span>
          </div>);
      })}
    </div>
  </div>
);
